import useSocketReconnect from '../utils/useSocketReconnect';
import Pissarra from './pissarra/Pissarra'
import Controller from './pissarra/controller/Controller'
import FloatingButtons from './pissarra/floating/FloatingButtons'
import PissarraController from './pissarra/PissarraController'
import './PissarraApp.css'

import { applyChange } from '../utils/loadPositions'
import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import Importer from './pissarra/importer/Importer'
import useImportModelPaths from './pissarra/importer/useImportModelPaths'
import { can } from '../utils/permissions'
import { isBrowser } from 'react-device-detect'
import PissarraAids from './pissarra/PissarraAids'

import moment from 'moment'
import { NoSignal } from './Interface'
import Projector from './pissarra/projector/Projector'
import ReadOnlyButtons from './pissarra/readonly/ReadOnlyButtons'
import { applyTimeZone } from '../utils/utils'
import { fetchAPI, fetchAPIquery, getSubdomain } from '../utils/utils'
import { addAddons } from './editor/EditorApp'
import usePinyaCopilot from './pissarra/copilot/usePinyaCopilot'
import useTemporaryPerson from './pissarra/controller/useTemporaryPerson'
import TemporaryPersonNotice from './pissarra/controller/TemporaryPersonNotice'
import useBoardPositions from './pissarra/useBoardPositions'

const COLLA = getSubdomain()

function PissarraApp({ castellersInfo, setCastellersInfo, socket, readonly, serverId, setServerId, ...props }) {
    useSocketReconnect(socket, () => {
        if (COLLA === 'xoriguers') socket.emit('.request_all_events');
    });

  // API variables
  const params = window.location.pathname.split('/').filter(part => part != '');
  const isInProjector = params.length > 0 && ['esdeveniments', 'assaigs', 'activitats', 'actuacions'].includes(params[0]);

  const defaultEvent = isInProjector ? params[1] : params[0];
  const defaultCastell = isInProjector ? params[2] : params[1];
  const defaultVersio = isInProjector ? params[3] : params[2];
  const effectiveUserInfo = castellersInfo?.[props.userId] || props.userInfo || {};

  const [selectedEvent, setSelectedEvent] = useState(defaultEvent || null);
  const [selectedBundle, setSelectedBundle] = useState(defaultCastell || null);
  const [selectedVersio, setSelectedVersio] = useState(defaultVersio || null);
  const [boardCastellersInfo, setBoardCastellersInfo] = useState(castellersInfo || {});
  const boardCastellersRequestRef = useRef(0);
  const boardAttendanceRequestRef = useRef(0);

  const [castellerSelected, setCastellerSelected] = useState(-1);
  const [caixaSelected, setCaixaSelected] = useState(-1);
  const [pz, setPanzoom] = useState(null);
  const [swiper, setSwiper] = useState(null);
  const { posicions, setPosicions, posicionsLog, setPosicionsLog } = useBoardPositions();
  const [assistenciesEvent, setAssistenciesEvent] = useState(null)

  const [lastCaixes, setLastCaixes] = useState({ 'prev': -1, 'current': -1 });
  const [ajuntament, setAjuntament] = useState(null);
  const [ajuntamentLabel, setAjuntamentLabel] = useState('');
  const [ajuntamentEmoji, setAjuntamentEmoji] = useState('');
  const [pissarraConfig, setPissarraConfig] = useState({ ajuntamentLabel: '', ajuntamentEmoji: '', savedOptions: [] });
  const [hideAjuntament, setHideAjuntament] = useState(true);
  const [ajuntamentModalClosed, setAjuntamentModalClosed] = useState(true);
  const [extended, setExtended] = useState(false);

  const [selectedEventInfo, setSelectedEventInfo] = useState(null)
  const [horesProves, setHoresProves] = useState(null)
  const [proves, setProves] = useState({ 'event': -1, 'private': [], 'public': [], 'admin': [] })

  const [rotationVal, setRotationVal] = useState(0);
  const [importing, setImporting] = useState(null);
  // Load alongside the board and keep the paths ready between imports.
  // The model folders are «Pinyes Model» (ACCESS_MODELS): without it the server refuses them
  const modelPaths = useImportModelPaths({ enabled: !readonly && can(effectiveUserInfo, 'ACCESS_MODELS'), userId: props.userId, socket });

  const [targetEvent, setTargetEvent] = useState(null)
  const [targetAssistencies, setTargetAssistencies] = useState(null)
  const [allEvents, setAllEvents] = useState([])

  const [hoveredUser, setHoveredUser] = useState(null)
  const [initializationOpacity, setInitializationOpacity] = useState(0);

  const [pestanya, setPestanya] = useState('Pinya')
  const [tabs, setTabs] = useState([])

  const [addons, setAddons] = useState(null)
  const [json, setJSON] = useState({});

  const [triggerClick, setTriggerClick] = useState(false)
  const [castellBeingImported, setCastellBeingImported] = useState(null)
  const [nextChangeFromSuggestion, setNextChangeFromSuggestion] = useState(false)
  const [copilotRetryToken, setCopilotRetryToken] = useState(0)

  const [lastLlista, setLastLlista] = useState(null)
  const [fontSize, setFontSize] = useState(14);

  const MODELS_EVENT_ID = 999999
  const isModel = parseInt(selectedEvent) === parseInt(MODELS_EVENT_ID)

  const withAddons = addAddons(json, addons);

  const visibleEmptyCaixaIds = useMemo(() => {
    const allCaixes = Object.entries(withAddons || {})
      .filter(([, caixa]) => caixa?.type === 'caixa');

    const normalizedPestanya = String(pestanya || '').toLowerCase();
    const pestanyedCaixes = allCaixes.filter(([, caixa]) =>
      (COLLA === 'falconsbcn' || COLLA === 'falconsvila' || COLLA === 'falconspiera' || COLLA === 'falconsvilanova') ||
      (!caixa?.pestanya && normalizedPestanya === 'pinya') ||
      caixa?.pestanya === normalizedPestanya
    );
    const caixesKeys = pestanyedCaixes.map(([caixaId]) => caixaId);

    const hasCordons = caixesKeys
      .filter(caixaId =>
        normalizedPestanya
          ? withAddons?.[caixaId]?.pestanya === normalizedPestanya || (!withAddons?.[caixaId]?.pestanya && normalizedPestanya === 'pinya')
          : true
      )
      .filter(caixaId => withAddons?.[caixaId]?.cordo !== undefined && withAddons?.[caixaId]?.cordo !== null && withAddons?.[caixaId]?.cordo !== '')
      .length > 0;

    const longestOccupiedCordo = caixesKeys
      .filter(caixaId =>
        normalizedPestanya
          ? withAddons?.[caixaId]?.pestanya === normalizedPestanya || (!withAddons?.[caixaId]?.pestanya && normalizedPestanya === 'pinya')
          : true
      )
      .filter(caixaId => Object.prototype.hasOwnProperty.call(posicions?.caixes || {}, caixaId))
      .map(caixaId => parseInt(withAddons?.[caixaId]?.cordo, 10))
      .filter(cordo => !Number.isNaN(cordo))
      .sort((a, b) => b - a)[0] || 0;

    const showUntil = Math.max(
      longestOccupiedCordo,
      tabs.map(t => t.toLowerCase()).includes('puntals') ? 8 :
      tabs.map(t => t.toLowerCase()).includes('manilles') ? 5 :
      tabs.map(t => t.toLowerCase()).includes('folre') ? 3 :
      2
    );

    const visibilityLimit = normalizedPestanya === 'pinya' && hasCordons
      ? showUntil + 1
      : Number.MAX_SAFE_INTEGER;

    return caixesKeys
      .filter(caixaId => {
        const parsedCordo = parseInt(withAddons?.[caixaId]?.cordo, 10);
        const hasValidCordo = !Number.isNaN(parsedCordo);
        const isVisible = !hasValidCordo || parsedCordo <= visibilityLimit;
        const isEmpty = !Object.prototype.hasOwnProperty.call(posicions?.caixes || {}, caixaId);
        return isVisible && isEmpty;
      })
      .sort((a, b) => String(a).localeCompare(String(b)));
  }, [
    JSON.stringify(withAddons || {}),
    pestanya,
    JSON.stringify(posicions?.caixes || {}),
    JSON.stringify(tabs || []),
  ]);

  const { copilotStatus, copilotSuggestion, acceptCopilotSuggestion, dismissCopilotSuggestion } = usePinyaCopilot({
    readonly,
    selectedEvent,
    selectedBundle,
    selectedVersio,
    pestanya,
    caixaSelected,
    posicions,
    assistenciesEvent,
    setCastellerSelected,
    setNextChangeFromSuggestion,
    visibleEmptyCaixaIds,
    withAddons,
    retryToken: copilotRetryToken,
  });

  const setCaixaSelectedWithRetry = useCallback((nextCaixaId) => {
    setCaixaSelected(prevCaixaId => {
      if (
        String(prevCaixaId) === String(nextCaixaId) &&
        String(nextCaixaId) !== '-1'
      ) {
        setCopilotRetryToken(prev => prev + 1);
      }

      return nextCaixaId;
    });
  }, []);

  const matchedProva = (horesProves || [])
    .filter(hores => {
        const [castell, versio, _] = hores.prova.split('.')
        return selectedBundle === castell && selectedVersio === versio
    })
    [0] || null

  const arribenTard = (assistenciesEvent || [])
    .filter(data => moment(data['data-entrada']).isValid())
    .filter(data => parseInt(data['assistència']) === 1)
    .filter(data => matchedProva ? moment(matchedProva.start) < applyTimeZone(data['data-entrada']) : false)
    .map(data => parseInt(data.id))

  const surtenAviat = (assistenciesEvent || [])
    .filter(data => moment(data['data-sortida']).isValid())
    .filter(data => parseInt(data['assistència']) === 1 || parseInt(data['assistència']) === 2)
    .filter(data => matchedProva ? applyTimeZone(data['data-sortida']) < moment(matchedProva.end) : false)
    .map(data => parseInt(data.id))

  const openLlista = () => {
    if (swiper && swiper.realIndex === 0) {
      if (lastLlista && !isNaN(lastLlista)) {
        swiper.slideTo(lastLlista, 0);
      } else {
        swiper.slideTo(1, 0);
      }
    }
  }

  const applyPissarraConfig = useCallback((data) => {
    setPissarraConfig({
      ajuntamentLabel: typeof data?.ajuntamentLabel === 'string' ? data.ajuntamentLabel : '',
      ajuntamentEmoji: typeof data?.ajuntamentEmoji === 'string' ? data.ajuntamentEmoji : '',
      savedOptions: Array.isArray(data?.savedOptions) ? data.savedOptions : [],
    })
  }, [])

  const refreshPissarraConfig = useCallback(() => {
    fetchAPI('/pissarra_config', applyPissarraConfig, false)
  }, [applyPissarraConfig])

  const refreshBoardCastellersInfo = useCallback(() => {
    const requestId = ++boardCastellersRequestRef.current;
    const eventQuery = selectedEvent ? `?eventId=${encodeURIComponent(selectedEvent)}` : '';

    fetchAPI(`/castellersInfo${eventQuery}`, data => {
      if (requestId === boardCastellersRequestRef.current && data) {
        setBoardCastellersInfo(previous => ({ ...data,
          ...Object.fromEntries(Object.entries(previous).filter(([id]) => Number(id) < -1)),
        }));
      }
    }, false)
  }, [selectedEvent])

  const refreshBoardAttendance = useCallback(() => {
    if (!selectedEvent) return;
    const requestId = ++boardAttendanceRequestRef.current;
    fetchAPI(`/all_assistencies_event/${selectedEvent}`, data => {
      if (requestId === boardAttendanceRequestRef.current && Array.isArray(data?.data)) {
        setAssistenciesEvent(previous => [...data.data, ...(previous || []).filter(person => person.id < -1)]);
      }
    }, false);
  }, [selectedEvent]);

  useEffect(() => {
    const onTemporaryChange = ({ eventId } = {}) => {
      if (String(eventId) === String(selectedEvent)) {
        refreshBoardCastellersInfo();
        refreshBoardAttendance();
      }
    };
    socket.on('.temporary_castellers_changed', onTemporaryChange);
    return () => socket.off('.temporary_castellers_changed', onTemporaryChange);
  }, [socket, selectedEvent, refreshBoardCastellersInfo, refreshBoardAttendance]);

  const exports = {
    'socket': socket,

    'selectedEvent': selectedEvent,
    'selectedBundle': selectedBundle,
    'selectedVersio': selectedVersio,

    'lastLlista': lastLlista,
    'setLastLlista': setLastLlista,
    'openLlista': openLlista,
    
    'json': json,
    'setJSON': setJSON,
    'addons': addons,
    'setAddons': setAddons,

    'fontSize': fontSize,
    'setFontSize': setFontSize,

    'swiper': swiper,
    'setSwiper': setSwiper,
    'panzoom': pz,
    'setPanzoom': setPanzoom,
    'castellerSelected': castellerSelected,
    'setCastellerSelected': setCastellerSelected,
    'caixaSelected': caixaSelected,
    'setCaixaSelected': setCaixaSelectedWithRetry,
    'posicions': posicions,
    'setPosicions': setPosicions,
    'posicionsLog': posicionsLog,
    'setPosicionsLog': setPosicionsLog,
    'castellersInfo': boardCastellersInfo,
    'setCastellersInfo': setBoardCastellersInfo,
    'refreshCastellersInfo': refreshBoardCastellersInfo,
    'readonly': readonly,
    'lastCaixes': lastCaixes,
    'setLastCaixes': setLastCaixes,

    'assistenciesEvent': assistenciesEvent,
    'setAssistenciesEvent': setAssistenciesEvent,

    'setSelectedEvent': setSelectedEvent,
    'setSelectedBundle': setSelectedBundle,
    'setSelectedVersio': setSelectedVersio,

    'castellBeingImported': castellBeingImported,
    'setCastellBeingImported': setCastellBeingImported,
    'nextChangeFromSuggestion': nextChangeFromSuggestion,
    'setNextChangeFromSuggestion': setNextChangeFromSuggestion,
    'importing': importing,
    'setImporting': setImporting,

    'ajuntament': ajuntament,
    'setAjuntament': setAjuntament,
    'ajuntamentLabel': ajuntamentLabel,
    'setAjuntamentLabel': setAjuntamentLabel,
    'ajuntamentEmoji': ajuntamentEmoji,
    'setAjuntamentEmoji': setAjuntamentEmoji,
    'pissarraConfig': pissarraConfig,
    'refreshPissarraConfig': refreshPissarraConfig,
    'hideAjuntament': hideAjuntament,
    'setHideAjuntament': setHideAjuntament,
    'ajuntamentModalClosed': ajuntamentModalClosed,
    'setAjuntamentModalClosed': setAjuntamentModalClosed,
    'extended': extended,
    'setExtended': setExtended,

    'selectedEventInfo': selectedEventInfo,
    'horesProves': horesProves,
    'proves': proves,

    'initializationOpacity': initializationOpacity,
    'setInitializationOpacity': setInitializationOpacity,

    'rotationVal': rotationVal,
    'setRotationVal': setRotationVal,

    'arribenTard': arribenTard,
    'surtenAviat': surtenAviat,
    'matchedProva': matchedProva,

    'targetEvent': targetEvent,
    'setTargetEvent': setTargetEvent,
    'targetAssistencies': targetAssistencies,
    'setTargetAssistencies': setTargetAssistencies,

    'pestanya': pestanya,
    'setPestanya': setPestanya,
    'tabs': tabs,
    'setTabs': setTabs,

    'triggerClick': triggerClick,
    'setTriggerClick': setTriggerClick,
    'isModel': isModel,
    'copilotStatus': copilotStatus,
    'copilotSuggestion': copilotSuggestion,
    'acceptCopilotSuggestion': acceptCopilotSuggestion,
    'dismissCopilotSuggestion': dismissCopilotSuggestion,

    'serverId': serverId,
    'setServerId': setServerId,

    'withAddons': withAddons,
    'visibleEmptyCaixaIds': visibleEmptyCaixaIds,
    'hoveredUser': hoveredUser,
    'setHoveredUser': setHoveredUser,

    ...props,
    'userInfo': effectiveUserInfo,
  };

  const temporaryPeople = useTemporaryPerson(exports);
  exports.createTemporaryPerson = temporaryPeople.createTemporaryPerson;
  exports.removeTemporaryPerson = temporaryPeople.removeTemporaryPerson;

  useEffect(() => {
    if (selectedBundle !== null && selectedVersio !== null) {
      // document.title = `${selectedBundle} ${readonly ? '(🎥) ' : '' }- Aleta`;
    } else if (selectedBundle === null) {
      document.title = `Projector - Aleta`;
      setExtended(true);
    }

    const onNewConnection = id => setServerId(id);
    socket.on('.new_connection', onNewConnection);

    return () => socket.off('.new_connection', onNewConnection);
  }, [selectedBundle, selectedVersio]);

  const parametrizeOption = (name, options) =>
    options
      ?.replace('OPTIONS:', '')
      ?.split(',')
      ?.map(str => str.split('='))
      ?.filter(([key, val]) => key === name)
      ?.map(([key, val]) => parseInt(val))
      ?.filter(val => !isNaN(val))
      [0] || 0

  // Com parametrizeOption però per valors de text (guardats URI-encoded)
  const parametrizeStringOption = (name, options) => {
    const rawValue = options
      ?.replace('OPTIONS:', '')
      ?.split(',')
      ?.map(str => str.split('='))
      ?.filter(([key]) => key === name)
      ?.map(([key, ...valueParts]) => valueParts.join('='))
      ?.[0] || ''

    try {
      return decodeURIComponent(rawValue)
    } catch (e) {
      return rawValue
    }
  }

  useEffect(() => {
    refreshPissarraConfig()
  }, [refreshPissarraConfig])

  useEffect(() => {
    const handleLabelChanged = payload => {
      if (typeof payload === 'string') {
        setAjuntamentLabel(payload)
        return
      }

      setAjuntamentLabel(typeof payload?.label === 'string' ? payload.label : '')
      setAjuntamentEmoji(typeof payload?.emoji === 'string' ? payload.emoji : '')
    }

    socket.on('.ajuntament_label_changed', handleLabelChanged)
    socket.on('.pissarra_config_updated', applyPissarraConfig)

    return () => {
      socket.off('.ajuntament_label_changed', handleLabelChanged)
      socket.off('.pissarra_config_updated', applyPissarraConfig)
    }
  }, [socket, applyPissarraConfig])

  useEffect(() => {
    refreshBoardAttendance();
    socket.on('connect', refreshBoardAttendance);
    socket.on('.user_change', refreshBoardAttendance);
    return () => {
      boardAttendanceRequestRef.current += 1;
      socket.off('connect', refreshBoardAttendance);
      socket.off('.user_change', refreshBoardAttendance);
    };
  }, [socket, castellersInfo, serverId, refreshBoardAttendance])

  useEffect(() => {
    setBoardCastellersInfo(castellersInfo || {});
    refreshBoardCastellersInfo();

    return () => { boardCastellersRequestRef.current += 1; };
  }, [castellersInfo, selectedEvent, serverId, refreshBoardCastellersInfo])

  useEffect(() => {
    if (targetEvent) fetchAPI(`/all_assistencies_event/${targetEvent}`, data => setTargetAssistencies(data.data), false)
  }, [targetEvent])

  useEffect(() => {
    if (COLLA !== 'xoriguers') return;

    socket.emit('.request_all_events');
    const handleEvents = (events) => {
      const sortedEvents = [...events].sort((a, b) => moment(a['data-esperada-inici']).diff(moment(b['data-esperada-inici'])));
      setAllEvents(sortedEvents);
    };

    socket.on('.events', handleEvents);
    return () => socket.off('.events', handleEvents);
  }, [socket]);

  useEffect(() => {
    if (COLLA !== 'xoriguers') return;
    if (!selectedEventInfo) return;
    if (selectedEventInfo.tipus !== 'assaig') return;
    if (!Array.isArray(allEvents) || allEvents.length === 0) return;

    const selectedEventStart = selectedEventInfo['data-esperada-inici']
      ? applyTimeZone(selectedEventInfo['data-esperada-inici'])
      : null;

    if (!selectedEventStart) return;

    const futureEvents = allEvents.filter(event => {
      const eventStart = event['data-esperada-inici'] ? applyTimeZone(event['data-esperada-inici']) : null;
      return eventStart ? eventStart.isAfter(selectedEventStart) : false;
    });

    if (futureEvents.length === 0) return;

    const now = moment();

    const currentTarget = futureEvents.find(event => parseInt(event.id) === parseInt(targetEvent));

    const isCurrentTargetValid = currentTarget
      && currentTarget['data-esperada-fi']
      && applyTimeZone(currentTarget['data-esperada-fi']).isAfter(now);

    if (isCurrentTargetValid) return;

    const nextActuacio = futureEvents
      .filter(event => event.tipus === 'actuació')
      .filter(event => event['data-esperada-fi'] ? applyTimeZone(event['data-esperada-fi']).isAfter(now) : false)
      .sort((a, b) => {
        const aStart = a['data-esperada-inici'] ? applyTimeZone(a['data-esperada-inici']) : null;
        const bStart = b['data-esperada-inici'] ? applyTimeZone(b['data-esperada-inici']) : null;

        if (!aStart && !bStart) return 0;
        if (!aStart) return 1;
        if (!bStart) return -1;

        return aStart.diff(bStart);
      })[0];

    if (nextActuacio && String(nextActuacio.id) !== String(targetEvent || '')) {
      setTargetEvent(String(nextActuacio.id));
    }
  }, [allEvents, selectedEventInfo, targetEvent, setTargetEvent]);

  const selectedBoxPerson = caixaSelected !== -1 ? posicions.caixes[caixaSelected] ?? null : null;
  useEffect(() => {
    // Follow this box's occupant, including removals and optimistic rollbacks.
    // Unrelated board changes must not interrupt previews from the picker.
    setHoveredUser(selectedBoxPerson);
  }, [caixaSelected, selectedBoxPerson]);

  // useEffect(() => {
  //     fetchAPIquery(`/positions/${selectedEvent}/${selectedBundle}/${selectedVersio}`, (res) => {
  //       if ('url' in res) {
  //           fetch(res.url)
  //               .then(data => data.text())
  //               .then(data => {
  //                   if (data.split('\n').length > 0) {
  //                       setAjuntament(parametrizeOption('ajuntament', data.split('\n')[0]))
  //                       setPosicionsLog(data.split('\n').slice(1))
  //                   }
  //               })
  //       }
  //   }, false, false, {
  //       force_disk: 0
  //   })
  // }, [selectedEvent, selectedBundle, selectedVersio])

  // Reset bundle data (only when bundle changes)
  useEffect(() => {
    if (!selectedEvent || !selectedBundle) {
      setJSON({});
      setAddons(null);
      return;
    }
    setJSON({});
    setAddons(null);
  }, [selectedEvent, selectedBundle]);

  // Reset prova data (when any of event/bundle/versio changes)
  useEffect(() => {
    if (!selectedEvent) {
      setPosicions({ 'caixes': {}, 'castellers': {}, 'loading': true });
      setPosicionsLog(null);
      setImporting(false);
      setCastellBeingImported(null);
      setTriggerClick(false);
      setCaixaSelected(-1);
      setCastellerSelected(-1);
      setNextChangeFromSuggestion(false);
      setHoveredUser(null);
      return;
    }
    if (!selectedBundle || !selectedVersio) return;

    setPosicions({ 'caixes': {}, 'castellers': {}, 'loading': true });
    setPosicionsLog(null);
    setImporting(false);
    setCastellBeingImported(null);
    setTriggerClick(false);
    setCaixaSelected(-1);
    setCastellerSelected(-1);
    setNextChangeFromSuggestion(false);
    setHoveredUser(null);
  }, [selectedEvent, selectedBundle, selectedVersio]);

  useEffect(() => {
    const room = (selectedEvent && selectedBundle && selectedVersio)
      ? `${selectedEvent}.${selectedBundle}.${selectedVersio}`
      : null;

    if (room) socket.emit('.prova_info', selectedEvent, selectedBundle, selectedVersio);
    if (selectedEvent) fetchAPI(`/hores_proves/${selectedEvent}`, data => setHoresProves(data), false)
    if (selectedEvent) fetchAPI(`/event/${selectedEvent}`, data => setSelectedEventInfo(data))
    if (selectedEvent) fetchAPI(`/proves/${selectedEvent}`, data => setProves(data))

    if (selectedEvent && selectedBundle && selectedVersio) socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio);

    const onLoadedPositions = res => {
      if (res.event === selectedEvent && res.castell === selectedBundle && res.versio === selectedVersio) {
        if ('error' in res) {
          console.log(res.error)
        } else if (res.data.split('\n').length > 0) {
          setAjuntament(parametrizeOption('ajuntament', res.data.split('\n')[0]))
          setAjuntamentLabel(parametrizeStringOption('etiqueta', res.data.split('\n')[0]))
          setAjuntamentEmoji(parametrizeStringOption('emoji', res.data.split('\n')[0]))
          setPosicionsLog(res.data.split('\n').slice(1))
        }
      }
    };
    socket.on('.loaded_positionsv2', onLoadedPositions);

    const onUndidAction = action_id => socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio)
    socket.on('.undid_action', onUndidAction)

    const onNewOrder = () => {
      fetchAPI(`/hores_proves/${selectedEvent}`, data => setHoresProves(data), false)
    }
    socket.on('.new_order', onNewOrder)

    const onProvesUpdated = (event) => {
      if (parseInt(event) === parseInt(selectedEvent)) {
        fetchAPI(`/proves/${selectedEvent}`, data => setProves(data))
        fetchAPI(`/hores_proves/${selectedEvent}`, data => setHoresProves(data), false)
      }
    }
    socket.on('.proves_updated', onProvesUpdated)

    socket.on('.user_change', refreshBoardCastellersInfo)

    const onConfirmat = res => {
      const assistenciaNum = res.assistencia === 'Fitxat' ? 2 :
        res.assistencia === 'Vinc' ? 1 :
        res.assistencia === 'No vinc' ? 0 :
        undefined

      const updateFields = (data) => ({
        ...data,
        'assistencia': res.assistencia,
        'assistència': assistenciaNum,
        'data-entrada': typeof res.entrada !== 'undefined' ? res.entrada : data['data-entrada'],
        'data-sortida': typeof res.sortida !== 'undefined' ? res.sortida : data['data-sortida']
      });

      if (parseInt(res.event) === parseInt(selectedEvent)) {
        // Refresh profile flags and people created since the board was opened.
        refreshBoardAttendance();
        setAssistenciesEvent(prev => {
          return [...(prev || [])].map(data => parseInt(data.id) === parseInt(res.user) ? updateFields(data) : data)
        })
      } else if (parseInt(res.event) === parseInt(targetEvent)) {
        setTargetAssistencies(prev => {
          return [...prev].map(data => parseInt(data.id) === parseInt(res.user) ? updateFields(data) : data)
        })
      }
    };
    socket.on('.confirmat', onConfirmat);
    const onNewChange = pos => applyChange(exports, pos);
    socket.on('.new_change', onNewChange);
    const onBoardError = ({ room: failedRoom, error }) => {
      if (failedRoom !== room) return;
      socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio);
      window.alert(error || 'No s’ha pogut desar el canvi.');
    };
    socket.on('.board_change_error', onBoardError);
    const onHoresProves = (event, data) => parseInt(event) === parseInt(selectedEvent) && setHoresProves(data)
    socket.on('.hores_proves', onHoresProves)

    return () => {
      if (room) socket.emit('.leave_room', room);
      socket.off('.confirmat', onConfirmat);
      socket.off('.loaded_positionsv2', onLoadedPositions);
      socket.off('.new_change', onNewChange);
      socket.off('.board_change_error', onBoardError);
      socket.off('.hores_proves', onHoresProves)
      socket.off('.user_change', refreshBoardCastellersInfo);
      socket.off('.new_order', onNewOrder);
      socket.off('.proves_updated', onProvesUpdated);
      socket.off('.undid_action', onUndidAction)
    }
  }, [targetEvent, selectedEvent, selectedBundle, selectedVersio, serverId, refreshBoardCastellersInfo, refreshBoardAttendance]);

  useEffect(() => {
    if (!importing) {
      setCastellBeingImported(null)
    }
  }, [importing])

  useEffect(() => {
    if (Object.keys(withAddons).length === 0) return;
    if (posicions.loading) return;

    const pisosRellevants = ['pinya', 'folre', 'manilles', 'puntals']

    const isPisPintat = Object.fromEntries(
      pisosRellevants
        .map(pis => {
          const doesPisExist = Object.values(withAddons)
            .filter(caixa => typeof caixa === 'object')
            .filter(caixa => caixa?.pestanya?.toLowerCase() === pis.toLowerCase())
            .length >= 1

          if (!doesPisExist) return [pis, true]

          const isActualPisPintat = Object.keys(posicions['caixes'])
            .map(caixa => withAddons[caixa])
            .filter(caixa => typeof caixa === 'object')
            .filter(caixa => caixa?.pestanya?.toLowerCase() === pis.toLowerCase())
            .filter(caixa => !('pilar' in caixa))
            .length >= 1

          return [pis, isActualPisPintat]
        })
    )

    const nonTroncCaixesOccupied = Object.keys(posicions['caixes'])
      .map(caixa => withAddons[caixa])
      .filter(caixa => typeof caixa === 'object')
      .filter(caixa => !('pilar' in caixa) && caixa?.pestanya?.toLowerCase() !== 'tronc')

    const totalCaixesOccupied = Object.keys(posicions['caixes'])
      .map(caixa => withAddons[caixa])
      .filter(caixa => typeof caixa === 'object') 


    const isProvaNetaPintada = totalCaixesOccupied.length >= 1
    const isActualPestanyaPintada = isPisPintat[pestanya.toLowerCase()] === true

    const isProvaNeta = !['pinya', 'folre', 'manilles', 'puntals'].includes(pestanya.toLowerCase())
    const isProvaPintada = isProvaNeta ? isProvaNetaPintada : isActualPestanyaPintada

    if (importing !== false && !isProvaPintada) {
      if (selectedBundle && selectedVersio) {
        setImporting(true)
      }
    }
  }, [withAddons, posicions, pestanya])

  return (
    <>
      <NoSignal socket={socket} />
      {!readonly && <TemporaryPersonNotice notice={temporaryPeople.notice} onDismiss={temporaryPeople.dismissNotice} />}
      {!readonly && importing && <Importer parametrizeOption={parametrizeOption} {...exports} modelPaths={modelPaths} />}
      {(!readonly) && !importing && <FloatingButtons {...exports} />}
      { readonly && <ReadOnlyButtons {...exports} /> }
      {!readonly && <PissarraController {...exports} />}
      { selectedBundle && selectedVersio && !importing && <PissarraAids {...exports} /> }
      <Pissarra
        {...exports}
        selectedEventInfo={selectedEventInfo}
      />
      {!readonly && !importing && <Controller {...exports} />}
      {readonly && <Projector {...exports} />}
    </>
  );
}

export default PissarraApp;
